import { render } from "./ModalBuilding.vue?vue&type=template&id=22b5aa40&scoped=true"
import script from "./ModalBuilding.vue?vue&type=script&lang=js"
export * from "./ModalBuilding.vue?vue&type=script&lang=js"

import "./ModalBuilding.vue?vue&type=style&index=0&id=22b5aa40&lang=scss&scoped=true"
import "./ModalBuilding.vue?vue&type=style&index=1&id=22b5aa40&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b5aa40"]])

export default __exports__